import axios from 'axios'
import ApiService from "@/services/ApiService";

const googleMaps = axios.create({
    baseURL: `https://maps.googleapis.com/maps/api/geocode/json`,
    timeout: 180000 /* 3 minutes */,
    headers: {},

})
export const findLatitudeAndLongitude = async (user) => {
    try {
        const apiService = new ApiService()

        const body = {
            cep: user.postalCode,
            logradouro: user.addressName,
            complemento: user.addressComplement,
            unidade: null,
            bairro: user.neighborhood,
            localidade: user.city,
            uf: user.state,
            estado: user.state,
            regiao: user.region,
            ibge: null,
            gia: null,
            ddd: null,
            siafi: null
        };


        return new Promise((resolve, reject) => {
            apiService.post(`Address/geocode`, body)
                .then((response) => {
                    const { content } = response || {};
                    const { results } = content || {};
                    const [{ geometry }] = results || [];
                    const { location } = geometry || {};
                    const { lat, lng } = location || {};
                    return resolve({lat, lng})
                })
                .catch((error) => {
                    return resolve(error.response)
                })
        })
    } catch (error) {
    }
}
